/* Velezeco - Free gift auto-add (nativo, sem app) para tema Vex/Maestrooo.
   Orientado a eventos: escuta 'cart:change' (o tema ja manda o carrinho).
   Ao mexer no brinde, dispara 'cart:refresh'. Erro nunca quebra o carrinho.

   2026-08-21
   - THRESHOLD 4 -> 1: o brinde entra em TODO pedido ("+ FREE GIFT ON ALL ORDERS").
   - RECUSA: se o cliente remover o brinde na mao, NAO recolocamos. A recusa vale
     enquanto durar a aba (sessionStorage) e e zerada quando o carrinho esvazia.
   - TRAVA ANTI-COBRANCA: se a Shopify nao zerar o preco do brinde (os descontos
     "GIFT" e "2 FREE" hoje nao combinam e disputam os mesmos itens), removemos o
     brinde em vez de deixar o cliente pagar por algo anunciado como gratis.
     Assim que as duas regras puderem combinar no admin, essa trava fica inerte.

   2026-08-25
   - Auto-adicao do 2o oculos REMOVIDA a pedido do Simon: o carrinho nao coloca
     mais sozinho um segundo par quando o cliente adiciona o primeiro. Todo par
     extra passa a vir de uma acao do cliente. Sairam junto a chave de sessao e as
     funcoes/variaveis auxiliares que existiam so para isso.

   2026-10-04
   - DOIS brindes, nao um. A escada do bundle tem dois cards com cadeado e cada um
     entra num degrau diferente, entao o carrinho precisa da mesma escada:
         brinco  -> 4 pares (3o marco da barra, "3 FREE GIFT")
         colar   -> 6 pares
     2026-10-05: o brinco subiu de 3 para 4 para casar com a barra de progresso,
     que marca o brinde so no terceiro degrau. Antes ele entrava em 3 e a barra
     ainda mostrava o brinde como bloqueado.
     Tudo que era por brinde (recusa, trava anti-cobranca, "ja tinha") passou a
     viver dentro de cada entrada de BRINDES. A contagem de pares ignora TODOS os
     brindes, senao o proprio brinco contaria como par e o colar entraria cedo.
   - Uma acao por passagem, como antes. Se sobrar coisa a fazer, o `chain` ja
     reavalia ate estabilizar, com teto anti-loop.
   - O colar tem SELETOR DE LETRA no card do bundle. A escolha chega aqui pelo
     sessionStorage ('vz_colar_variante'), porque este script roda no carrinho e
     nao enxerga o <select> da pagina do produto. Por isso o colar e reconhecido
     por PRODUTO e nao por variante: qualquer uma das 26 letras e o mesmo brinde.
     Se a letra mudar com o colar ja no carrinho, trocamos a linha. */
(function () {
  if (window.__vzFreeGift) return; window.__vzFreeGift = true;

  var BRINDES = [
    /* 2026-10-30 (Simon): o brinco voltou a entrar em QUALQUER carrinho, min 4 -> 1,
       no modelo da fernfitness.co ("Bonus Free Gift in Cart"). */
    { id: 52286973673809, min: 1, chave: 'vz_gift_declined', nome: 'brinco' }

    /* 2026-10-30 — O COLAR SAIU DAQUI. BUG ACHADO: o produto "Initial Necklace
       (Free Gift)" nunca foi publicado, segue em DRAFT com estoque 0 e politica
       DENY. Entao todo carrinho que chegava a 6 pares pedia /cart/add.js dessa
       variante, a Shopify devolvia 422, o script nao olhava o status da resposta
       e tentava de novo, em loop, ate a Shopify cortar a sessao com 429. Com 429
       o /cart.js tambem caia, o tema nao conseguia redesenhar a gaveta e o BRINCO
       sumia da tela. Era esse o "brinde sumiu".
       Para voltar com o colar: publicar o produto, deixar estoque disponivel (ou
       politica CONTINUE) e recolocar a linha abaixo.
       { produto: 11210738663761, padrao: 55175990477137, min: 6,
         chave: 'vz_gift_declined_colar', nome: 'colar', letra: 'vz_colar_variante' } */
  ];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var busy = false, pending = false;
  var chain = 0;               // acoes encadeadas seguidas (teto de seguranca)
  var weRemoved = false;       // a ultima remocao foi nossa, nao do cliente
  var userTouchedLine = false; // o cliente mexeu numa linha do carrinho agora ha pouco

  for (var i = 0; i < BRINDES.length; i++) {
    BRINDES[i].blockedAtPairs = null; // evita loop quando o brinde vem cobrado
    BRINDES[i].hadGift = false;       // tinha esse brinde na leitura anterior
    BRINDES[i].falhas = 0;            // quantas vezes a Shopify recusou esse brinde
    BRINDES[i].desligado = false;     // recusado demais: para de pedir nesta aba
  }

  function declined(b) {
    try { return sessionStorage.getItem(b.chave) === '1'; } catch (e) { return false; }
  }
  function setDeclined(b, v) {
    try { v ? sessionStorage.setItem(b.chave, '1') : sessionStorage.removeItem(b.chave); } catch (e) {}
  }
  // Um brinde pode ser uma variante fixa (brinco) ou um produto inteiro (colar,
  // 26 letras que valem a mesma coisa). Devolve a entrada de BRINDES ou null.
  function brindeDe(it) {
    for (var k = 0; k < BRINDES.length; k++) {
      var b = BRINDES[k];
      if (b.id && it.variant_id === b.id) return b;
      if (b.produto && it.product_id === b.produto) return b;
    }
    return null;
  }
  // Qual variante deve estar no carrinho agora. Para o colar, a letra que o cliente
  // escolheu no bundle; sem escolha, a primeira letra.
  function escolhida(b) {
    if (!b.produto) return b.id;
    try {
      var v = parseInt(sessionStorage.getItem(b.letra), 10);
      if (v) return v;
    } catch (e) {}
    return b.padrao;
  }

  function reconcile(cart) {
    if (!cart || !cart.items) return;
    if (busy) { pending = true; return; }

    // pares = tudo que NAO e brinde. Com dois brindes no carrinho, contar errado
    // aqui faria o colar entrar com 4 oculos em vez de 6.
    var linhas = {}, pairs = 0;
    cart.items.forEach(function (it) {
      var b = brindeDe(it);
      if (b) { linhas[b.nome] = it; return; }
      pairs += it.quantity;
    });

    // carrinho esvaziou -> zera as recusas: o proximo pedido volta a ganhar brinde
    if (pairs === 0) {
      for (var z = 0; z < BRINDES.length; z++) {
        setDeclined(BRINDES[z], false);
        BRINDES[z].blockedAtPairs = null;
        BRINDES[z].falhas = 0;
        BRINDES[z].desligado = false;
      }
    }

    // o brinde sumiu -> so tratamos como RECUSA se o cliente mexeu numa linha do
    // carrinho (o tema dispara 'line-item:change' nesse caso). As nossas proprias
    // remocoes usam cart/change.js via fetch e NAO disparam esse evento, e corridas
    // de re-render tambem nao — assim a recusa nunca e marcada por engano.
    for (var d = 0; d < BRINDES.length; d++) {
      var bd = BRINDES[d], gd = linhas[bd.nome] || null;
      if (bd.hadGift && !gd && !weRemoved && userTouchedLine) setDeclined(bd, true);
      bd.hadGift = !!gd;
    }
    weRemoved = false;
    userTouchedLine = false;

    // uma acao por passagem. A ordem de BRINDES define a prioridade: o brinco
    // (degrau menor) resolve antes do colar.
    var action = null;
    for (var n = 0; n < BRINDES.length && !action; n++) {
      var b = BRINDES[n], gift = linhas[b.nome] || null;

      if (gift && gift.final_line_price > 0) {
        // anunciado como gratis mas veio cobrado: tira, nao deixa o cliente pagar
        b.blockedAtPairs = pairs; weRemoved = true;
        action = { url: 'cart/change.js', body: { id: gift.key, quantity: 0 }, brinde: b };
      } else if (gift && gift.variant_id !== escolhida(b)) {
        // o cliente trocou a letra com o colar ja no carrinho: sai a linha antiga.
        // A passagem seguinte adiciona a letra nova, pelo mesmo caminho de sempre.
        weRemoved = true;
        action = { url: 'cart/change.js', body: { id: gift.key, quantity: 0 }, brinde: b };
      } else if (pairs >= b.min && !gift && !declined(b) && !b.desligado && pairs !== b.blockedAtPairs) {
        action = { url: 'cart/add.js', body: { items: [{ id: escolhida(b), quantity: 1, properties: { _free_gift: 'true' } }] }, brinde: b };
      } else if (pairs < b.min && gift) {
        // caiu abaixo do degrau: o brinde daquele degrau sai junto
        weRemoved = true;
        action = { url: 'cart/change.js', body: { id: gift.key, quantity: 0 }, brinde: b };
      } else if (gift && gift.quantity !== 1) {
        action = { url: 'cart/change.js', body: { id: gift.key, quantity: 1 }, brinde: b };
      }
    }

    if (!action) { chain = 0; return; } // estabilizou: zero rede, zero re-render

    busy = true;
    var paresDaAcao = pairs;
    fetch(ROOT + action.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(action.body) })
      .then(function (r) {
        /* 2026-10-30 — ANTES ESTE .then IGNORAVA O STATUS. Se a Shopify recusava
           (422 variante indisponivel, 429 pedimos rapido demais), o script achava
           que tinha dado certo, mandava redesenhar, reavaliava, pedia de novo, e
           girava em loop ate derrubar o carrinho inteiro. Agora uma recusa trava
           aquele brinde naquele numero de pares, e na segunda recusa ele para de
           ser pedido nesta aba. O carrinho do cliente segue funcionando. */
        if (!r.ok) {
          var b = action.brinde;
          if (b) {
            b.falhas++;
            b.blockedAtPairs = paresDaAcao;
            if (b.falhas >= 2) b.desligado = true;
          }
          return;
        }
        if (action.brinde) action.brinde.falhas = 0;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'vz-gift' } }));
      })
      .catch(function () { if (action.brinde) { action.brinde.falhas++; action.brinde.blockedAtPairs = paresDaAcao; } })
      .finally(function () {
        busy = false;
        // uma acao pode destravar outra (ex.: removemos um brinde cobrado e agora
        // cabe adicionar o gratuito, ou o brinco entrou e falta o colar).
        // Reavaliamos ate estabilizar, com teto anti-loop. Teto subiu de 4 para 6
        // porque com dois brindes um unico evento pode render mais acoes.
        if (pending) { pending = false; chain = 0; fetchCartThen(reconcile); }
        else if (chain < 6) { chain++; fetchCartThen(reconcile); }
        else { chain = 0; }
      });
  }

  function fetchCartThen(cb) {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(cb).catch(function () {});
  }

  // sinal do proprio tema de que o CLIENTE alterou uma linha (inclui remover)
  document.addEventListener('line-item:change', function () { userTouchedLine = true; });

  // 'cart:refresh' e o aviso de quem mexe no carrinho por fora do tema: o bundle
  // da pagina do produto e o nosso conserto do Remove. Sem escutar isso o brinde
  // nao entrava quando o cliente comprava pelo bundle.
  var respiro = null;
  function aoRefrescar(e) {
    if (e && e.detail && e.detail.source === 'vz-gift') return;  // foi a gente
    clearTimeout(respiro);
    respiro = setTimeout(function () { fetchCartThen(reconcile); }, 400);
  }
  document.addEventListener('cart:refresh', aoRefrescar);
  document.documentElement.addEventListener('cart:refresh', aoRefrescar);

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) reconcile(cart);
    else fetchCartThen(reconcile);
  });

  fetchCartThen(reconcile);
})();
